import { motion } from "framer-motion";
import { useSearchParams } from "react-router-dom";
import { Phone, Mail, MapPin, User } from "lucide-react";
import { EnquiryForm } from "../components/EnquiryForm";
import { SEO } from "../components/SEO";

const DETAILS = [
  { icon: User, label: "Contact", value: "Victor — Sales & Marketing" },
  { icon: Phone, label: "Mobile", value: "+64 22 159 8639", href: "tel:+64221598639" },
  { icon: Mail, label: "Email", value: "sales@vrpackaging.co.nz", href: "mailto:sales@vrpackaging.co.nz" },
  { icon: MapPin, label: "Address", value: "14 Tony Segedin Drive, Avondale, Auckland 1026" },
];

export default function Contact() {
  const [sp] = useSearchParams();
  const sku = sp.get("sku") || "";
  return (
    <main data-testid="contact-page" className="pt-28 pb-20 md:pb-28 bg-vr-bg">
      <SEO
        title="Contact VR Packaging & Hygiene | Request a Wholesale Quote"
        description="Get in touch with VR Packaging & Hygiene. Wholesale packaging, hygiene, cleaning and safety supplies for NZ businesses — quote replies within one business day."
        path="/contact"
      />
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <span className="text-xs tracking-[0.2em] uppercase text-vr-brand font-semibold">Contact</span>
          <h1 className="mt-4 font-display font-extrabold tracking-tight leading-[1.02] text-4xl md:text-6xl text-vr-ink">
            {sku ? "Request bulk pricing." : "Let's talk supply."}
          </h1>
          <p className="mt-6 text-vr-dim leading-relaxed max-w-md">
            {sku ? `We'll send wholesale pricing and availability for ${sku} and anything else you need.` : "Send us your requirements and our team will get back to you within one business day with pricing and recommendations."}
          </p>

          <div className="mt-10 space-y-5">
            {DETAILS.map((d) => (
              <div key={d.label} className="flex items-start gap-4">
                <span className="grid place-items-center w-11 h-11 rounded-xl bg-vr-brand/10 text-vr-brand shrink-0"><d.icon size={20} /></span>
                <div>
                  <div className="text-xs uppercase tracking-wider text-vr-dim">{d.label}</div>
                  {d.href ? (
                    <a href={d.href} className="text-vr-ink font-medium hover:text-vr-brand transition-colors">{d.value}</a>
                  ) : (
                    <div className="text-vr-ink font-medium">{d.value}</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        <div className="bg-white rounded-3xl border border-vr-border shadow-sm p-6 md:p-8">
          <EnquiryForm initialSku={sku} />
        </div>
      </div>
    </main>
  );
}
